
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404HzRMo2X_tTYsQybG1GDXZfVVyPKAjnYN_iNwaSnVG3wMeta } from "/opt/build/repo/pages/404.vue?macro=true";
import { default as blogott0gEtTQ54v6DRdlKf31kyIevIxP_XAC9xUUVixlzYMeta } from "/opt/build/repo/pages/blog.vue?macro=true";
import { default as helpuH07qzkOvD4BBgzjHC2ul2qcIArXr39Xs_450hEyW4iFUMeta } from "/opt/build/repo/pages/help.vue?macro=true";
import { default as quitBCQO3HrvKiCWIy_0WSZOlCkytyokHPtdYgO9ndB7Qo8Meta } from "/opt/build/repo/pages/quit.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as pressSN9ksu5UViGPnjgTVNNr_45aJay6NE_45A8WBv42fUILlCcMeta } from "/opt/build/repo/pages/press.vue?macro=true";
import { default as termsxPmI_bz3lr0COX220qY_45hhLw9jpIPZB3X_C_45C0YXikUMeta } from "/opt/build/repo/pages/terms.vue?macro=true";
import { default as search40azIuQO_45V5O416T2UUEtXxMQd2LugEuEKr9RgZDQWkMeta } from "/opt/build/repo/pages/search.vue?macro=true";
import { default as careersWbGto89aEc1z8EnTsh1HDAaeNG_45O__frVGvCVJBqpQAMeta } from "/opt/build/repo/pages/careers.vue?macro=true";
import { default as contactUtUBN6u09MOBXpCX2V4MTnIvODrHK3on_Sjbujn1zJsMeta } from "/opt/build/repo/pages/contact.vue?macro=true";
import { default as imprintwxAFMlW8sx45WM5DANMLo00et36c3q6JOBqv2hJiEOUMeta } from "/opt/build/repo/pages/imprint.vue?macro=true";
import { default as privacyJgcQvwZubR6yhc6N8xh1MhZ2ByebxVuUx1uXOag5a9UMeta } from "/opt/build/repo/pages/privacy.vue?macro=true";
import { default as sciencehlsHq4827sBcvpbuCkMhDhlkpMCGW2DXtrt_451wqTIUcMeta } from "/opt/build/repo/pages/science.vue?macro=true";
import { default as for_45workAjC5JvP0OJRb6Xv0BrRqJAXc_gCa7BOMW_45ICOxe_45N4cMeta } from "/opt/build/repo/pages/for-work.vue?macro=true";
import { default as registereUFPUgCXbUbkM74KdKqZIrJcc_QOIXBANMYTn5YpRlAMeta } from "/opt/build/repo/pages/register.vue?macro=true";
import { default as challengehPzj4DH_45WACjCgoonWdXTNtz9b5XKIoF90IpagsouGUMeta } from "/opt/build/repo/pages/challenge.vue?macro=true";
import { default as manifestot3HIfyU0mGuASsuUME895dDCG_WZQcs96vxmTCG_geIMeta } from "/opt/build/repo/pages/manifesto.vue?macro=true";
import { default as subscribemZ07GIHyBN6PEIzd6c5qsXFAMdm1PIzycl_45GxV4oAJ8Meta } from "/opt/build/repo/pages/subscribe.vue?macro=true";
import { default as _91id_93BCJn1_IYkSq8b1_45s8lXpZSw1591Rgk4QrmX85iHv71AMeta } from "/opt/build/repo/pages/posts/[id].vue?macro=true";
import { default as invite26wIUalMRhKdcoFPqOxzj5fcwEdhzFuAk8NqPDTBHnUMeta } from "/opt/build/repo/pages/link/invite.vue?macro=true";
import { default as maintenanceO1O6Wd8rMYbf0goQJ7tXA4SIcw_5UMJYGBYTI1XMmoEMeta } from "/opt/build/repo/pages/maintenance.vue?macro=true";
import { default as data_45deletionmIxnQ5GsOfcMaTuxrrA1Ig7kPD8dNBrwX_l1uKTYig8Meta } from "/opt/build/repo/pages/data-deletion.vue?macro=true";
import { default as success_45delete_45accountgsPDi63K4HP5Vrz1wyvUbsvTTvZne4vi3xMhCu12wsQMeta } from "/opt/build/repo/pages/success-delete-account.vue?macro=true";
import { default as success_45reset_45passwordRVTxU2vtwkutXUCFpzavBs0YlCeJtOex_musTH7qMnAMeta } from "/opt/build/repo/pages/success-reset-password.vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "404___en",
    path: "/404",
    component: () => import("/opt/build/repo/pages/404.vue")
  },
  {
    name: "404___de",
    path: "/de/404",
    component: () => import("/opt/build/repo/pages/404.vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/opt/build/repo/pages/blog.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    component: () => import("/opt/build/repo/pages/blog.vue")
  },
  {
    name: "help___en",
    path: "/help",
    component: () => import("/opt/build/repo/pages/help.vue")
  },
  {
    name: "help___de",
    path: "/de/hilfe",
    component: () => import("/opt/build/repo/pages/help.vue")
  },
  {
    name: "quit___en",
    path: "/quit",
    component: () => import("/opt/build/repo/pages/quit.vue")
  },
  {
    name: "quit___de",
    path: "/de/quit",
    component: () => import("/opt/build/repo/pages/quit.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "press___en",
    path: "/press",
    component: () => import("/opt/build/repo/pages/press.vue")
  },
  {
    name: "press___de",
    path: "/de/press",
    component: () => import("/opt/build/repo/pages/press.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    component: () => import("/opt/build/repo/pages/terms.vue")
  },
  {
    name: "terms___de",
    path: "/de/terms",
    component: () => import("/opt/build/repo/pages/terms.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/opt/build/repo/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/opt/build/repo/pages/search.vue")
  },
  {
    name: "careers___en",
    path: "/careers",
    component: () => import("/opt/build/repo/pages/careers.vue")
  },
  {
    name: "careers___de",
    path: "/de/karriere",
    component: () => import("/opt/build/repo/pages/careers.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/kontakt",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "imprint___en",
    path: "/imprint",
    component: () => import("/opt/build/repo/pages/imprint.vue")
  },
  {
    name: "imprint___de",
    path: "/de/imprint",
    component: () => import("/opt/build/repo/pages/imprint.vue")
  },
  {
    name: "privacy___en",
    path: "/privacy",
    component: () => import("/opt/build/repo/pages/privacy.vue")
  },
  {
    name: "privacy___de",
    path: "/de/privacy",
    component: () => import("/opt/build/repo/pages/privacy.vue")
  },
  {
    name: "science___en",
    path: "/science",
    component: () => import("/opt/build/repo/pages/science.vue")
  },
  {
    name: "science___de",
    path: "/de/science",
    component: () => import("/opt/build/repo/pages/science.vue")
  },
  {
    name: "for-work___en",
    path: "/for-work",
    component: () => import("/opt/build/repo/pages/for-work.vue")
  },
  {
    name: "for-work___de",
    path: "/de/for-work",
    component: () => import("/opt/build/repo/pages/for-work.vue")
  },
  {
    name: "register___en",
    path: "/register",
    component: () => import("/opt/build/repo/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    component: () => import("/opt/build/repo/pages/register.vue")
  },
  {
    name: "challenge___en",
    path: "/challenge",
    meta: challengehPzj4DH_45WACjCgoonWdXTNtz9b5XKIoF90IpagsouGUMeta || {},
    component: () => import("/opt/build/repo/pages/challenge.vue")
  },
  {
    name: "challenge___de",
    path: "/de/challenge",
    meta: challengehPzj4DH_45WACjCgoonWdXTNtz9b5XKIoF90IpagsouGUMeta || {},
    component: () => import("/opt/build/repo/pages/challenge.vue")
  },
  {
    name: "manifesto___en",
    path: "/manifesto",
    component: () => import("/opt/build/repo/pages/manifesto.vue")
  },
  {
    name: "manifesto___de",
    path: "/de/manifest",
    component: () => import("/opt/build/repo/pages/manifesto.vue")
  },
  {
    name: "subscribe___en",
    path: "/subscribe",
    component: () => import("/opt/build/repo/pages/subscribe.vue")
  },
  {
    name: "subscribe___de",
    path: "/de/subscribe",
    component: () => import("/opt/build/repo/pages/subscribe.vue")
  },
  {
    name: "posts-id___en",
    path: "/posts/:id()",
    component: () => import("/opt/build/repo/pages/posts/[id].vue")
  },
  {
    name: "posts-id___de",
    path: "/de/posts/:id()",
    component: () => import("/opt/build/repo/pages/posts/[id].vue")
  },
  {
    name: "link-invite___en",
    path: "/link/invite",
    meta: invite26wIUalMRhKdcoFPqOxzj5fcwEdhzFuAk8NqPDTBHnUMeta || {},
    component: () => import("/opt/build/repo/pages/link/invite.vue")
  },
  {
    name: "link-invite___de",
    path: "/de/link/invite",
    meta: invite26wIUalMRhKdcoFPqOxzj5fcwEdhzFuAk8NqPDTBHnUMeta || {},
    component: () => import("/opt/build/repo/pages/link/invite.vue")
  },
  {
    name: "maintenance___en",
    path: "/maintenance",
    component: () => import("/opt/build/repo/pages/maintenance.vue")
  },
  {
    name: "maintenance___de",
    path: "/de/maintenance",
    component: () => import("/opt/build/repo/pages/maintenance.vue")
  },
  {
    name: "data-deletion___en",
    path: "/data-deletion",
    component: () => import("/opt/build/repo/pages/data-deletion.vue")
  },
  {
    name: "data-deletion___de",
    path: "/de/data-deletion",
    component: () => import("/opt/build/repo/pages/data-deletion.vue")
  },
  {
    name: "success-delete-account___en",
    path: "/success-delete-account",
    component: () => import("/opt/build/repo/pages/success-delete-account.vue")
  },
  {
    name: "success-delete-account___de",
    path: "/de/success-delete-account",
    component: () => import("/opt/build/repo/pages/success-delete-account.vue")
  },
  {
    name: "success-reset-password___en",
    path: "/success-reset-password",
    component: () => import("/opt/build/repo/pages/success-reset-password.vue")
  },
  {
    name: "success-reset-password___de",
    path: "/de/success-reset-password",
    component: () => import("/opt/build/repo/pages/success-reset-password.vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sitemap",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/de/sitemap",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]